<template lang="pug">
v-img(
  v-bind="{ ...$attrs, ...sqipArgs }"
  v-on="$listeners"
).k-img
  template(v-slot)
    slot
</template>

<script>
export default {
  props: {
    sqip: {
      type: Object,
      default: null,
      required: false,
    }
  },
  computed: {
    sqipArgs () {
      if (!this.sqip) {
        return {}
      }
      return {
        src: this.sqip.src,
        lazySrc: this.sqip.preview,
      }
    }
  }
}
</script>
